import React from 'react';
import styled from 'styled-components';
import * as colors from '../../../../colors';
export default function SectionWrapper({ children, subHeader, SubHeaderIcon, }) {
    return (React.createElement("div", { className: "flex flex-col" },
        React.createElement(SubHeader, null,
            SubHeaderIcon,
            subHeader),
        React.createElement(SectionWrapperStyle, null, children)));
}
const SectionWrapperStyle = styled.div `
  padding-bottom: 12px;
  margin-bottom: 12px;
`;
const SubHeader = styled.div `
  font-size: 14px;
  color: ${colors.FONT_THIRD};
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-top: 28px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
`;
